//flow
export function extractYoutubeVideoId(queryUrl: string) {
  try {
    const url = new URL(queryUrl);

    const query = url.searchParams.get('v');

    return query || '';
  } catch (error) {
    console.log('error getting video youtube id', error);
    return '';
  }
}

type PosterOptions = {
  webp?: boolean,
  poster?: 'hqdefault' | 'mqdefault' | 'sddefault' | 'maxresdefault',
};

export function getYoutubePosterUrl(
  videoId: string,
  {webp, poster}: PosterOptions = {}
) {
  const format = webp ? 'webp' : 'jpg';
  const vi = webp ? 'vi_webp' : 'vi';
  const posterImp = poster || 'maxresdefault';

  return `https://i.ytimg.com/${vi}/${videoId}/${posterImp}.${format}`;
}
